import React, { useEffect, useState } from "react";
import { TOGGLE_LINK_COMMAND } from '@lexical/link';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { validateUrl } from '../../utils';

// mui
import Button from '@mui/material/Button';
//import Checkbox from '@mui/material/Checkbox';
//import FormControlLabel from '@mui/material/FormControlLabel';
//import FormGroup from '@mui/material/FormGroup';
import Menu from '@mui/material/Menu';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

// types
type propsType = {
    anchorEl: null | HTMLElement,
    handleClose: () => void,
    isOpen: boolean,
};

const LinkModal = (props: propsType) => {
    const { anchorEl, handleClose, isOpen } = props;
    //const [isOpeningInNewTab, setIsOpeningInNewTab] = useState(false);
    const [urlValue, setUrlValue] = useState("");
    const [editor] = useLexicalComposerContext();

    // リンク挿入の処理
    const fnAddLink = (
        //isOpeningInNewTab: boolean,
        urlValue: string,
    ) => {
        if (validateUrl(urlValue)) {
            editor.dispatchCommand(TOGGLE_LINK_COMMAND, urlValue);
            fnCloseLinkModal();
        } else {
            setIsUrlError(true)
        }
    };

    /** リセット用関数 */
    const fnCloseLinkModal = () => {
        handleClose();
        //setIsOpeningInNewTab(false);
        setUrlValue('');
        setIsUrlError(false);
    };

    // URLバリデーション
    const [isUrlError, setIsUrlError] = useState(false);

    useEffect(() => {
        if (urlValue) {
            setIsUrlError(false);
        }
    }, [urlValue]);

    return (
        <>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={isOpen}
                onClose={() => {
                    handleClose();
                    setIsUrlError(false);
                }}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                sx={{
                    [`& .MuiPaper-root`]: {
                        p: 1.5,
                    },
                    [`& .MuiList-root`]: {
                        p: 0,
                    }
                }}
            >
                <TextField
                    error={isUrlError}
                    helperText={isUrlError ? "正しい形式で入力してください" : ""}
                    label="URL"
                    onChange={(event) => {
                        event.preventDefault();
                        setUrlValue(event.target.value);
                    }}
                    size="small"
                    value={urlValue}
                    variant="outlined"
                />
                {/*<FormGroup>*/}
                {/*    <FormControlLabel*/}
                {/*        control={*/}
                {/*            <Checkbox*/}
                {/*                checked={isOpeningInNewTab}*/}
                {/*                onChange={() => setIsOpeningInNewTab((e) => !e)}*/}
                {/*                size="small"*/}
                {/*            />*/}
                {/*        }*/}
                {/*        label="別タブで開く"*/}
                {/*        sx={{*/}
                {/*            [`& .MuiTypography-root`]: {*/}
                {/*                fontSize: 14,*/}
                {/*            },*/}
                {/*        }}*/}
                {/*    />*/}
                {/*</FormGroup>*/}
                <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                    <Button onClick={fnCloseLinkModal} size="small" variant="outlined">キャンセル</Button>
                    <Button onClick={() => {
                        //fnAddLink(isOpeningInNewTab, urlValue);
                        fnAddLink(urlValue);
                    }} variant="contained" size="small">挿入</Button>
                </Stack>
            </Menu>
        </>
    );
};

export default LinkModal;
    